/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'
import { get } from 'lodash'

/**
 * Import
 * - Actions
 */
import {
    fetchCountries,
    findLatLong,
    fetchOccupancies,
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import Step02cp from '../components/Step02cp/Step02cp'

const mapStateToProps = (state: RootState, props: any) => {

    return {
        quote: 'The QUOTE! Step02',
        riskLocations: props.riskLocations,
        addLocations: props.addLocations,
        addLocationsSecurity: props.addLocationsSecurity,
        deleteLocation: props.deleteLocation,
        countries: state.step00.countries,
        occupancies: get(state, 'step00.occupancies.data', []),
    }
}

export default connect(mapStateToProps, {
    getLatLong: findLatLong,
    fetchCountries,
    fetchOccupancies,
})(Step02cp)


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/containers/Step02cp.tsx